// The server's version id at the time this tab loaded index.html; requests
// whose X-App-Version differs from the current /web-booking-api/version come
// from a tab opened before the latest deploy. Still a placeholder under the
// Vite dev server.
const appVersion: string | undefined = (window as any).env?.appVersion;

const versionHeaders: Record<string, string> =
  appVersion && appVersion !== "__APP_VERSION__"
    ? { "X-App-Version": appVersion, "X-App-Platform": "web-booking" }
    : {};

export const apiFetch = (input: string, init?: RequestInit) => {
  const headers = new Headers(init?.headers);
  Object.entries(versionHeaders).forEach(([name, value]) =>
    headers.set(name, value)
  );
  return fetch(input, { ...init, headers });
};
